import api from '@/services/api/client';

/**
 * Absolut eller rot-relativ URL till API (för t.ex. `<img src>` som inte går via Axios Authorization-header).
 * Vid same-origin är baseURL tom → `/api/...` räcker (cookie skickas med).
 */
export function apiUrl(path: string): string {
  const p = path.startsWith('/') ? path : `/${path}`;
  const base = (api.defaults.baseURL ?? '').replace(/\/$/, '');
  return base ? `${base}${p}` : p;
}
